import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "../components/Modal/Modal";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../app/store";
import {
  selectFlags,
  setConfirmChangeSectionData,
  setSectionToChange,
} from "../reduxSlices/globalFlagsSlice";
import {
  addSectionChangeInProcess,
  addSubProcessSectionIds,
  removeSectionChangeInProcess,
  removeSubProcessSectionIds,
  selectInscribedSubjects,
  selectOfferedSubjects,
} from "../reduxSlices/subjectsSlice";
import { validarSuperposicionCambioSeccion } from "../Api/reservation";
import { changeSectionThunk } from "../reduxAsyncThunks/transaction.thunks";
import { useToastError } from "../hooks/useToast";
import OfferVirtualListContainer from "../components/OfferVirtualListContainer/OfferVirtualListContainer";
import "../components/DesktopOfferList/DesktopOfferList.css";
import { selectDebeAlertarSuperposicion } from "../reduxSlices/studentSlice";
import { getInscribedSubjectTitle, getOfferSubjectTitle } from "../utils/changeSection";
import InvalidatingOfferLoader from "../components/InvalidatingOfferLoader/InvalidatingOfferLoader";
import TransitionModal from "../components/TransitionModal/TransitionModal";
import { selectStudent } from "../reduxSlices/studentSlice";
import { isRejected } from "@reduxjs/toolkit";
import Translatable from "../components/Translatable/Translatable";
import { useTranslatedText } from "../contexts/TranslationContext";
import { useTranslatedSubjectTitle } from "../hooks/useTranslatedSubjectTitle";

const HomePage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const showError = useToastError();
  const inscripciones = useSelector(selectInscribedSubjects);
  const oferta = useSelector(selectOfferedSubjects);
  const student = useSelector(selectStudent);
  const debeAlertarSuperposicion = useSelector(selectDebeAlertarSuperposicion);

  const { sectionToChange, confirmChangeSectionData } = useSelector(selectFlags);
  const [showModalSuperposicion, setShowModalSuperposicion] = useState<boolean>(false);
  const [showModalChangeSection, setShowModalChangeSection] = useState<boolean>(false);
  const [cursoSuperpuesto, setCursoSuperpuesto] = useState<string>("");
  const [wasChangeSectionConfirmed, setWasChangeSectionConfirmed] = useState<boolean>(false);
  const token = localStorage.getItem("token");
  const campusToken = localStorage.getItem("campusToken");
  const cancelLabel = useTranslatedText("Cancelar", { capitalize: true });
  const continueLabel = useTranslatedText("Continuar", { capitalize: true });
  const confirmLabel = useTranslatedText("Confirmar", { capitalize: true });
  const changeIntro = useTranslatedText("En caso de que el cambio NO sea posible, tu cupo original en");
  const changeOutro = useTranslatedText(
    "será reservado. De esta forma, no perderás tu cupo para cursar la materia.",
  );
  const inscribedTitle = useTranslatedSubjectTitle(
    sectionToChange ? getInscribedSubjectTitle(sectionToChange.idMateria, inscripciones) : "",
  );
  const offerTitle = useTranslatedSubjectTitle(
    sectionToChange ? getOfferSubjectTitle(sectionToChange.idMateria, sectionToChange.id, oferta) : "",
  );
  const overlapTitle = useTranslatedSubjectTitle(cursoSuperpuesto);
  const changeSubMessage = sectionToChange ? `${changeIntro} ${inscribedTitle} ${changeOutro}` : "";
  useEffect(() => {
    if (!token) {
      localStorage.clear();
      sessionStorage.clear();
      console.log("TOKEN NO PROPORCIONADO>> REDIRIGIENDO A LOGIN", { token, campusToken });
      navigate("/login");
    }
  }, []);

  useEffect(() => {
    if (debeAlertarSuperposicion && sectionToChange) {
      const validarDatos = async () => {
        if (sectionToChange && confirmChangeSectionData) {
          try {
            dispatch(
              addSectionChangeInProcess({ idCurso: sectionToChange.id, anioLectivo: sectionToChange.anioLectivo })
            );
            const { data } = await validarSuperposicionCambioSeccion(confirmChangeSectionData.reserveData);
            if (data.esValido === false) {
              setShowModalSuperposicion(true);
              setCursoSuperpuesto(data.extraData);
            } else if (data.esValido === true) {
              setShowModalChangeSection(true);
            }
          } catch (error) {
            dispatch(removeSectionChangeInProcess({ idCurso: sectionToChange.id, anioLectivo: sectionToChange.anioLectivo }));
            console.error("Error al validar superposición:", error);
          }
        }
      };
      validarDatos();
    } else if (sectionToChange) {
      dispatch(
        addSectionChangeInProcess({ idCurso: sectionToChange.id, anioLectivo: sectionToChange.anioLectivo })
      );
      setShowModalChangeSection(true);
    }
  }, [sectionToChange, confirmChangeSectionData]);

  const clearData = (shouldClearSectionChangeProcess = true) => {
    setShowModalSuperposicion(false);
    setShowModalChangeSection(false);
    dispatch(setSectionToChange(null));
    if (shouldClearSectionChangeProcess) {
      dispatch(
        removeSectionChangeInProcess({
          idCurso: sectionToChange?.id || 0,
          anioLectivo: sectionToChange?.anioLectivo || 0,
        })
      );
    }
  };

  const handlTryChangeSection = async (idCurso: number, anioLectivo: number) => {
    //dispatch(addSubProcessSectionIds({ idCurso, anioLectivo }));
    dispatch(setSectionToChange(null));

    try {
      const changeSectionResult = await dispatch(
        changeSectionThunk({
          //@ts-ignore
          tic: confirmChangeSectionData.reserveData.tic,
          //@ts-ignore
          tim: confirmChangeSectionData.reserveData.tim,
          //@ts-ignore
          idC: confirmChangeSectionData.reserveData.idC,
          //@ts-ignore
          idA: confirmChangeSectionData.reserveData.idA,
          //@ts-ignore
          idS: confirmChangeSectionData.reserveData.idS,
          //@ts-ignore
          aL: confirmChangeSectionData.reserveData.aL,
          //@ts-ignore
          idMateria: confirmChangeSectionData.reserveData.idMateria,
          //@ts-ignore
          idPersona: confirmChangeSectionData.reserveData.idPersona,
        })
      );
      if (isRejected(changeSectionResult)) {
        showError(changeSectionResult.payload as string);
      }
    } catch (error: any) {
      dispatch(removeSubProcessSectionIds({ idCurso, anioLectivo }));
      dispatch(removeSectionChangeInProcess({ idCurso, anioLectivo }));
    }
    dispatch(setConfirmChangeSectionData(null));
    clearData(false);
    setWasChangeSectionConfirmed(false);
  };

  const handleConfirmacionSuperposicion = () => {
    setShowModalSuperposicion(false);
    setShowModalChangeSection(true);
  };

  if (!oferta && student.id) {
    return <TransitionModal open={true} text={"logoAnimado"} />;
  }

  return (
    <InvalidatingOfferLoader>
      <div style={{ height: "100%", display: "flex", flexDirection: "column", gap: "6px" }}>
        {/* <DesktopOfferList /> */}
        <OfferVirtualListContainer />
        {sectionToChange && showModalChangeSection && (
          <Modal
            open={true}
            onClose={() => clearData(!wasChangeSectionConfirmed)}
            message=""
            subMessage={changeSubMessage}
            topBorderWarn={false}
            closeButton={{
              label: cancelLabel,
              buttonFn: clearData,
              color: "#00C4B3",
            }}
            okButton={{
              label: continueLabel,
              buttonFn: async () => {
                setWasChangeSectionConfirmed(true);
                await handlTryChangeSection(sectionToChange.id, sectionToChange.anioLectivo);
              },
              color: "#00C4B3",
            }}
          />
        )}
        {sectionToChange && showModalSuperposicion && (
          <Modal
            open={true}
            onClose={clearData}
            message=""
            messageHtml={
              <p style={{ fontWeight: "400" }}>
                <Translatable as="span">Si cambias de sección a</Translatable>{" "}
                <strong>{offerTitle}</strong>{" "}
                <Translatable as="span">el horario se superpondrá con</Translatable>{" "}
                <strong>{overlapTitle}</strong>
                <Translatable as="span">. ¿Deseas confirmar igualmente?</Translatable>
              </p>
            }
            topBorderWarn={true}
            closeButton={{
              label: cancelLabel,
              buttonFn: clearData,
              color: "#f5a800",
            }}
            okButton={{
              label: confirmLabel,
              buttonFn: handleConfirmacionSuperposicion,
              color: "#f5a800",
            }}
          />
        )}
      </div>
    </InvalidatingOfferLoader>
  );
};

export default HomePage;
